import ylgnbudata from './raw/ylgnbu.json';

export const YlGnBuColorMap = type => {
  if (type === 'range') {
    return ylgnbudata;
  }
};
